import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-burger',
  templateUrl: './burger.component.html',
  styleUrls: ['./burger.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, MatIcon],
})
export class BurgerComponent {
  @Input({ required: true }) isOpen = false;
  @Output() toggleMenu = new EventEmitter<boolean>();

  _toggle() {
    this.isOpen = !this.isOpen;
    this.toggleMenu.emit(this.isOpen);
  }
}
